import { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  List,
  ListItemButton,
  ListItemText
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useLocation } from "react-router-dom";

export default function Configurations() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const mode = params.get("mode"); // "configurations" or "maintenance"

  // Dynamic heading
  const heading =
    mode === "maintenance" ? "Maintenance" : "Configurations";

  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);

  const [functionsList, setFunctionsList] = useState([]);
  const [selectedFunction, setSelectedFunction] = useState(null);

  const [itemsList, setItemsList] = useState([]);

  // Fetch Modules List
  useEffect(() => {
    fetch("https://apiservices.iepa.in:8191/iepa/api/modules/org/1")
      .then((res) => res.json())
      .then((data) => setModules(data))
      .catch(console.error);
  }, []);

  // Fetch Functions for Selected Module
  const loadFunctions = async (moduleName) => {
    setSelectedModule(moduleName);
    setSelectedFunction(null);
    setItemsList([]);

    try {
      const res = await fetch(
        `https://apiservices.iepa.in:8191/iepa/api/configuration/modules/${moduleName}/org/1`
      );
      const data = await res.json();

      const funcNames = [...new Set(data.map((d) => d.functionName))];
      setFunctionsList(funcNames);

      // group items for each function
      const grouped = {};
      data.forEach((d) => {
        if (!grouped[d.functionName]) grouped[d.functionName] = [];
        grouped[d.functionName].push(d.configuredItem);
      });

      setItemsList(grouped);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box p={2}>
      {/* 🔥 Dynamic page title */}
      <Typography variant="h4" mb={2}>
        {heading}
      </Typography>

      <Grid container spacing={2}>
        {/* LEFT COLUMN - MODULES */}
        <Grid item xs={4}>
          <Paper sx={{ height: "80vh", overflow: "auto" }}>
            <Typography variant="h6" p={2}>
              Modules List
            </Typography>

            <List>
              {modules.map((m, idx) => (
                <ListItemButton
                  key={idx}
                  selected={selectedModule === m.name}
                  onClick={() => loadFunctions(m.name)}
                >
                  <ListItemText primary={m.name} />
                </ListItemButton>
              ))}
            </List>
          </Paper>
        </Grid>

        {/* MIDDLE COLUMN - FUNCTIONS */}
        <Grid item xs={4}>
          <Paper sx={{ height: "80vh", overflow: "auto" }}>
            <Typography variant="h6" p={2}>
              Features
            </Typography>

            {selectedModule ? (
              <List>
                {functionsList.map((fn, idx) => (
                  <ListItemButton
                    key={idx}
                    selected={selectedFunction === fn}
                    onClick={() => setSelectedFunction(fn)}
                  >
                    <ListItemText primary={fn} />
                  </ListItemButton>
                ))}
              </List>
            ) : (
              <Typography p={2}>Select a module</Typography>
            )}
          </Paper>
        </Grid>

        {/* RIGHT COLUMN – ITEMS */}
        <Grid item xs={4}>
          <Paper sx={{ height: "80vh", overflow: "auto" }}>
            <Typography variant="h6" p={2}>
              Items
            </Typography>

            {selectedFunction ? (
              <DataGrid
                autoHeight
                rows={
                  (itemsList[selectedFunction] || []).map((item, idx) => ({
                    id: idx + 1,
                    item
                  })) || []
                }
                columns={[{ field: "item", headerName: "Function", flex: 1 }]}
                hideFooter
                rowHeight={40}
                sx={{
                  "& .MuiDataGrid-row": {
                    borderBottom: "1px solid red"   // 👈 bottom border
                  }
                }}
              />
            ) : (
              <Typography p={2}>Select a function</Typography>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
